
import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MealCategoryMiniEntity } from '../../domain/entities/MealCategoryMiniEntity'
import type { MealCategoryAdminListedDtoAdmin } from '@/backend/market'

export class MealCategoryMiniModel extends MealCategoryMiniEntity {
    constructor(dataDto: MealCategoryAdminListedDtoAdmin) {
        super()
        mapEntityProperties<MealCategoryMiniEntity>(this, dataDto)
    }
}